import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";

export default function NotFoundPage() {
  const { lang } = useLang();
  const isEn = lang === "en";

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://preventum-diez.de/404/" />
        <meta name="robots" content="noindex,follow" />
        <title>
          {isEn
            ? "Page not found | Preventum Diez"
            : "Seite nicht gefunden | Preventum Diez"}
        </title>
        <meta
          name="description"
          content={
            isEn
              ? "The requested page could not be found."
              : "Die angeforderte Seite konnte nicht gefunden werden."
          }
        />
      </Helmet>

      <section className="container-x py-24 md:py-36 text-center">
        <div className="eyebrow mb-4">404</div>

        <h1 className="font-display text-4xl md:text-6xl font-extrabold text-navy-dark">
          {isEn ? "Page not found" : "Seite nicht gefunden"}
        </h1>

        <p className="mt-5 text-lg text-ink-muted max-w-2xl mx-auto">
          {isEn
            ? "The requested address does not exist or is no longer available."
            : "Die aufgerufene Adresse existiert nicht oder ist nicht mehr verfügbar."}
        </p>

        <Link className="btn-primary mt-8" to={isEn ? "/en/" : "/"}>
          {isEn ? "Go to homepage" : "Zur Startseite"}
        </Link>
      </section>
    </>
  );
}
